<div class="status-wrap">
    <mat-form-field appearance="fill" class="status-{{ favorite.status }}">
        <!--    <mat-label>Statut du projet</mat-label>-->
        <mat-select disableOptionCentering [(ngModel)]="favorite.status" (ngModelChange)="edit($event)">
            <mat-option value="analyse" class="status-value status-value-analyse">
                <span class="status-dot status-dot-analyse"></span>{{ commonService.getStatusLib('analyse') }}
            </mat-option>
            <mat-option value="contact" class="status-value status-value-contact">
                <span class="status-dot status-dot-contact"></span>{{ commonService.getStatusLib('contact') }}
            </mat-option>
            <mat-option value="visite" class="status-value status-value-visite">
                <span class="status-dot status-dot-visite"></span>{{ commonService.getStatusLib('visite') }}
            </mat-option>
            <mat-option value="offre" class="status-value status-value-offre">
                <span class="status-dot status-dot-offre"></span>{{ commonService.getStatusLib('offre') }}
            </mat-option>
            <mat-option value="offre_ok" class="status-value status-value-offre_ok">
                <span class="status-dot status-dot-offre_ok"></span>{{ commonService.getStatusLib('offre_ok') }}
            </mat-option>
            <mat-option value="offre_ko" class="status-value status-value-offre_ko">
                <span class="status-dot status-dot-offre_ko"></span>{{ commonService.getStatusLib('offre_ko') }}
            </mat-option>
            <mat-option value="sell" class="status-value status-value-sell">
                <span class="status-dot status-dot-sell"></span>{{ commonService.getStatusLib('sell') }}
            </mat-option>
            <mat-option value="abandon" class="status-value status-value-abandon">
                <span class="status-dot status-dot-abandon"></span>{{ commonService.getStatusLib('abandon') }}
            </mat-option>
            <mat-option value="offre_reponse" class="status-value status-value-offre_reponse">
                <span class="status-dot status-dot-offre_reponse"></span>{{ commonService.getStatusLib('offre_reponse') }}
            </mat-option>
            <mat-option value="buy" class="status-value status-value-buy">
                <span class="status-dot status-dot-buy"></span>{{ commonService.getStatusLib('buy') }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
